import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { isAuthenticated } from '../../utils';

import env from '../../../env';
import { StyledSignInWithGoogleContainer } from './styledComponents';

const SignInWithGoogle = ({ onSignInWithGoogle, isLogin }) => {
  useEffect(() => {
    if (!window?.google?.accounts?.id) return;

    window.google.accounts.id.initialize({
      client_id: env?.GOOGLE_CLIENT_ID,
      callback: onSignInWithGoogle,
    });

    window.google.accounts.id.renderButton(
      document.getElementById('sing_in_with_google_button'),
      {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        width: '340px',
        shape: 'circle',
        logo_alignment: 'center',
        locale: 'en',
        text: isLogin ? 'signin_with' : 'signup_with',
      },
    );
    isLogin && !isAuthenticated() && window.google.accounts.id.prompt(); // One Tap dialog
  }, []);

  return (
    <StyledSignInWithGoogleContainer>
      <div className="g_id_signin" id="sing_in_with_google_button" />
    </StyledSignInWithGoogleContainer>
  );
};

SignInWithGoogle.propTypes = {
  onSignInWithGoogle: PropTypes.func.isRequired,
  isLogin: PropTypes.bool.isRequired,
};

export default SignInWithGoogle;
